/* Shared screen frame: 16 px side padding, sections 24–32 apart (DESIGN_SYSTEM §2.3) */
.screen {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding: var(--s4) var(--gutter) var(--s4);
}

/* A flex column's items default to min-width: auto, so a wide child (a table
   or chart meant to scroll in its own container) would otherwise stretch the
   whole screen instead of scrolling. */
.screen > * {
  min-width: 0;
}

.stack > * + * {
  margin-top: var(--s5);
}

.meta {
  color: var(--ink2);
}

/* Primary actions pinned to the bottom of the screen, in the thumb zone */
.bottom {
  margin-top: auto;
  padding-top: var(--s5);
}

.stickyBottom {
  position: sticky;
  bottom: 0;
  margin-top: auto;
  padding: var(--s4) 0;
  background: var(--panel);
}

.sectionHead {
  margin: var(--s6) 0 var(--s2);
}

.sectionHead:first-of-type {
  margin-top: var(--s5);
}

.sheetText {
  padding: var(--s3) 0 var(--s2);
  max-width: 68ch;
}
